module.exports = __webpack_public_path__ + "static/media/49_tn.02eaa3aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/49_tn.jpg
// module id = 358
// module chunks = 0